import { render, staticRenderFns } from "./recentAtEvaluations.vue?vue&type=template&id=0e9704c4"
import script from "./recentAtEvaluations.vue?vue&type=script&lang=js"
export * from "./recentAtEvaluations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports